var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "stats-panel" }, [
      _c("div", { staticClass: "stats-panel__column" }, [
        _c("h3", { staticClass: "stats-panel__heading" }, [
          _vm._v("Monthly Summary"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stats-panel__content" }, [
          _c("div", { staticClass: "stats-panel__fields" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedMonth,
                    expression: "selectedMonth",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedMonth = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.monthOptions, function (option) {
                return _c(
                  "option",
                  { key: option.value, domProps: { value: option.value } },
                  [_vm._v(_vm._s(option.name))]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedYear,
                    expression: "selectedYear",
                  },
                ],
                staticStyle: { "flex-grow": "0", width: "unset" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedYear = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.yearOptions, function (option) {
                return _c(
                  "option",
                  { key: option.value, domProps: { value: option.value } },
                  [_vm._v(_vm._s(option.name))]
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stats-panel__button" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-plain-primary",
              staticStyle: { "margin-top": "20px" },
              on: { click: _vm.handleDownloadMonthlyPdfCallback },
            },
            [
              _vm.downloadingMonthly
                ? _c("span", { staticClass: "pickstar-loading" })
                : _c("span", [
                    _c("i", { staticClass: "fa fa-cloud-download" }),
                    _vm._v(" Download "),
                  ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "stats-panel__column" }, [
        _c("h3", { staticClass: "stats-panel__heading" }, [
          _vm._v("Annual Report"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stats-panel__content" }, [
          _c("div", { staticClass: "stats-panel__fields" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedYearYearly,
                    expression: "selectedYearYearly",
                  },
                ],
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedYearYearly = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.yearOptions, function (option) {
                return _c(
                  "option",
                  { key: option.value, domProps: { value: option.value } },
                  [_vm._v(_vm._s(option.name))]
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stats-panel__button" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-plain-primary",
              staticStyle: { "margin-top": "20px" },
              on: { click: _vm.handleDownloadYearlyPdfCallback },
            },
            [
              _vm.downloadingYearly
                ? _c("span", { staticClass: "pickstar-loading" })
                : _c("span", [
                    _c("i", { staticClass: "fa fa-cloud-download" }),
                    _vm._v(" Download "),
                  ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "stats-panel__column" }, [
        _c("h3", { staticClass: "stats-panel__heading" }, [
          _vm._v("Custom Range"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stats-panel__content" }, [
          _c("span", [_vm._v("Template: ")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedTemplate,
                  expression: "selectedTemplate",
                },
              ],
              staticStyle: { "margin-bottom": "10px" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedTemplate = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.templateOptions, function (option) {
              return _c(
                "option",
                { key: option.value, domProps: { value: option.value } },
                [_vm._v(_vm._s(option.name))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "stats-panel__fields" },
            [
              _c("flatpickr", {
                staticClass: "form-control",
                attrs: {
                  config: _vm.flatPickerDateConfig,
                  placeholder: "Please Select",
                  name: "date",
                },
                model: {
                  value: _vm.dateRange,
                  callback: function ($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stats-panel__button" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-plain-primary",
              staticStyle: { "margin-top": "10px" },
              on: { click: _vm.handleDownloadCustomPdfCallback },
            },
            [
              _vm.downloadingCustom
                ? _c("span", { staticClass: "pickstar-loading" })
                : _c("span", [
                    _c("i", { staticClass: "fa fa-cloud-download" }),
                    _vm._v(" Download "),
                  ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("h2", [_vm._v("Reports")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }